import styled from 'styled-components'

export const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
  &.print {
    align-items: center;
    align-self: center;
    align-content: center;
  }
  .edit-btn-container {
    display: flex;
    justify-content: end;
    align-items: center;
    .edit-btn {
      display: flex;
    }
  }
`

export const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 2rem;
  .table {
  }
  .column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  table {
    thead {
      tr {
        border-bottom: 1px solid transparent;
        th {
          text-align: start;
          padding: 0.5rem;
        }
      }
    }
  }
  .table h3 {
    text-align: center;
    margin-bottom: 10px;
  }
  table {
    border-collapse: collapse;
    border: 1px solid #111;
    padding: 10px;
  }
  thead,
  tbody,
  tfoot {
    border: none;
  }
  th,
  td {
    border: 1px solid #111;
    text-align: left;
    padding: 8px;
    min-width: 40px;
  }

  thead {
    font-size: 0.8rem;
    font-weight: 500;
  }

  tbody {
    td {
      font-size: 12px;
    }
  }
`
